import { useEffect, useState } from "react";
import { observeUserById } from "src/service/users";

export function useUser(id) {
  const [error] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!id) {
      setUser(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const off = observeUserById(id, (user) => {
      setUser(user);
      setLoading(false);
    });
    return () => {
      off?.();
    };
  }, [id]);

  return { user, setUser, error, setLoading, loading };
}
